import { render, staticRenderFns } from "./create_site.vue?vue&type=template&id=0a3c31c6&scoped=true&"
import script from "./create_site.vue?vue&type=script&lang=js&"
export * from "./create_site.vue?vue&type=script&lang=js&"
import style0 from "./create_site.vue?vue&type=style&index=0&id=0a3c31c6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c31c6",
  null
  
)

export default component.exports